<template>
  <div class="d-flex fill-height w-full relative mt-2">
    <!-- <v-card flat class="d-flex flex-row w-full transparent"> -->
    <v-tabs
      v-model="activeTab"
      vertical
      background-color="transparent"
      show-arrows
      left
      class="mr-2 custom-tabs"
      style="width: 250px; min-width: 250px"
    >
      <v-tab :ripple="false" v-for="tab in tabs" :key="tab.id" class="tabsClass w-full border-b">
        {{ tab.name }}
      </v-tab>
    </v-tabs>

    <div style="width: calc(100%)">
      <div
        class="d-flex justify-end pa-2"
        v-if="activeTab === 2"
        style="position: absolute; right: 10px; top: 0px; z-index: 10"
      >
        <FilterPopOver :selectedCount="selectedCount">
          <v-card outlined class="w-72 p-4">
            <v-select
              v-model="monthFilter"
              :items="months"
              label="Select Month"
              dense
              outlined
              hide-details
              class="mb-4"
              @change="handleFilterChange"
              clearable
            ></v-select>
            <v-autocomplete
              v-model="searchFilter"
              :items="employees"
              :loading="loadingEmployees"
              :search-input.sync="employeeSearchInput"
              item-text="fullName"
              item-value="_id"
              label="Search Employee"
              dense
              outlined
              hide-details
              @change="handleFilterChange"
              clearable
              placeholder="Type to search..."
            >
              <template v-slot:item="{ item }">
                <v-list-item-content>
                  <v-list-item-title>{{ item.fullName }}</v-list-item-title>
                  <v-list-item-subtitle>{{ item.employeeId }}</v-list-item-subtitle>
                </v-list-item-content>
              </template>
            </v-autocomplete>
          </v-card>
        </FilterPopOver>
      </div>
      <component :is="currentTabComponent" v-bind="$attrs" ref="activeComponent" />
    </div>
    <!-- </v-card> -->
  </div>
</template>

<script>
import Templates from './Templates.vue'
import Reimbursements from './Reimbursements.vue'
import SalaryLogs from './SalaryLogs.vue'
import FilterPopOver from '@/components/FilterPopOver.vue'
import { debounce } from '@/utils/common'
import { axiosUrl } from '@/utils/workforceApi'
import TaxSubmission from '@/pages/Workforce/TaxSubmission.vue'

export default {
  name: 'SalaryTemplateConfig',
  components: {
    Templates,
    Reimbursements,
    SalaryLogs,
    FilterPopOver,
    TaxSubmission
  },
  data() {
    return {
      activeTab: 0,
      tabs: [
        { id: 0, name: 'Salary Templates', component: 'Templates' },
        { id: 1, name: 'Reimbursements Templates', component: 'Reimbursements' },
        { id: 2, name: 'Salary Logs', component: 'SalaryLogs' },
        { id: 3, name: 'Tax Submission', component: 'TaxSubmission' }
      ],
      monthFilter: '',
      searchFilter: '',
      months: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
      ],
      employees: [],
      loadingEmployees: false,
      employeeSearchInput: null,
      debouncedFetchEmployees: null
    }
  },
  computed: {
    currentTabComponent() {
      return this.tabs[this.activeTab].component
    },
    selectedCount() {
      let count = 0
      if (this.monthFilter) count++
      if (this.searchFilter) count++
      return count
    }
  },
  watch: {
    employeeSearchInput(val) {
      if (val) {
        this.debouncedFetchEmployees(val)
      }
    }
  },
  created() {
    this.debouncedFetchEmployees = debounce(this.fetchEmployees, 300)
  },
  methods: {
    async fetchEmployees(search) {
      this.loadingEmployees = true
      try {
        const params = {
          page: 1,
          limit: 20,
          search: search
        }
        const response = await this.$axios.get(axiosUrl.employees.getEmployees, { params })
        const users = response.data.users || []
        this.employees = users.map((u) => ({
          ...u,
          fullName: `${u.firstName || ''} ${u.lastName || ''}`.trim()
        }))
      } catch (error) {
        console.error('Error fetching employees:', error)
      } finally {
        this.loadingEmployees = false
      }
    },
    openCreateTemplate() {
      this.$nextTick(() => {
        const component = this.$refs.activeComponent
        if (!component) return

        if (this.activeTab === 0) {
          if (typeof component.openCreateTemplate === 'function') {
            component.openCreateTemplate()
          }
        } else if (this.activeTab === 1) {
          if (typeof component.openCreateDialog === 'function') {
            component.openCreateDialog()
          }
        } else if (this.activeTab === 2) {
          if (typeof component.openUploadDialog === 'function') {
            component.openUploadDialog()
          }
        }
      })
    },
    handleFilterChange() {
      this.$nextTick(() => {
        if (
          this.$refs.activeComponent &&
          typeof this.$refs.activeComponent.applyFilters === 'function'
        ) {
          this.$refs.activeComponent.applyFilters({
            month: this.monthFilter,
            search: this.searchFilter
          })
        }
      })
    }
  }
}
</script>

<style scoped>
.transparent {
  background-color: transparent !important;
}
.tabsClass {
  text-transform: capitalize !important;
  display: flex;
  align-self: flex-start;
  font-size: 14px !important;
  justify-content: flex-start;
  height: 40px !important;
  font-weight: 600;
}
</style>
<style>
.custom-tabs > .v-tabs-bar {
  border-right: 1px solid #c8c3c3 !important;
  height: 100vh !important;
}
.custom-tabs {
  height: 100vh;
}
</style>
